import React from "react";

function HtmlContent({ html, as: Tag = "span", className = "" }) {
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html || "" }} />;
}

export default HtmlContent;
